export default __webpack_public_path__ + "static/stats-component-bg-6d18f4e3a08aaccdd5542ed505f655e7.png";